import { createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import moment from 'moment';
import { PICKER_DATE_MASK } from 'shared/constants';
import { ICreateNews } from 'shared/types/news.types';

const initialState: ICreateNews[] = [];

export const newsSlice = createSlice({
  name: 'news',
  initialState,
  reducers: {
    news: (state, { payload }: PayloadAction<ICreateNews>) => {
      const now = moment();
      const withCreatedDate = { ...payload, created: now.format(PICKER_DATE_MASK), id: Math.random() * 100000 };
      state.push(withCreatedDate);
    },
    update: (state, { payload }: PayloadAction<ICreateNews>) => {
      return state.map(elem => {
        if (elem.id === payload.id) {
          return payload;
        }
        return elem;
      });
    },
  },
});

const news = (state: RootState) => state.entities.news;
const getOrganizations = createSelector(news, state => state);

export const selectors = { getOrganizations };
export const newsActions = newsSlice.actions;
export const reducer = newsSlice.reducer;
